import React from 'react'

export const AutoDetail = ({name, model, price, img, id}) => {
    /* storage/app/public/modelos/id/hash */
    return (
        <div className="autoDetail">
            <h1>{name}</h1>
            <h2>{model}</h2>
            <img src={`/storage/modelos/${id}/${img}`}/>
            <h2>CUOTA DESDE</h2>
            <h1>${price}</h1>
        </div>
    )
}
